import React, {useEffect, useMemo, useState} from 'react'
import styles from './skillActivity.module.scss'

import API from 'Class/API'
import Button from 'Components/UI/Button'
import ChoiceField from 'Components/UI/Field/ChoiceField'
import LoadImage from 'Components/Layout/LoadImage'
import RenderContent from 'Components/Layout/RenderContent'
import Spinner from 'Components/Feedback/Spinner'
import SkillActivityStatus from 'Components/UI/SkillActivityStatus'
import SkillActivitySubscriptions from './subscribers'

export const SkillActivity = ({
    community,
    getTranslation = () => {},
    onClose = () => {},
    onStatus = () => {},
    selected: selectedInput = {},
    skill
}) => {
    const [activity, setActivity] = useState(null)
    const [selected, setSelected] = useState(selectedInput)
    const [status, setStatus] = useState(null)

    const fetchActivity = async (id) => {
        const {activity: fetchedActivity} = await API.RequestAsync('skillActivities/view', {community, activity: id})
        setActivity(fetchedActivity)
    }

    const onActivity = (_, activityId) => {
        const {activities, image} = activity
        const selected = activities.find(({database_id}) => String(database_id) === String(activityId))
        const {database_id: id, title: name, description} = selected || {}
        setSelected({id, name, description, image})
    }

    const onStatusChange = (newStatus) => {
        const status = [newStatus, new Date().getTime()]
        setStatus(status)
        onStatus(selected?.id, status)
    }

    const parseImage = (input) =>
    {
        if (!Array.isArray(input))
        {
            return input
        }
        return input.length > 0 ? input[0] : null
    }

    useEffect(() =>
    {
        fetchActivity(skill)
    }, [skill])

    const activities = useMemo(() =>
    {
        if (!activity)
        {
            return null
        }
        const list = {};
        activity.activities.forEach(({database_id, title}) =>
        {
            list[String(database_id)] = title;
        });
        return list;
    }, [activity]);

    return (
        <div className={styles.modal}>
            <div className={styles.activities}>
                {activities && (
                    <div className={styles.items}>
                        <h3>{getTranslation('activities')}</h3>
                        <ChoiceField
                            className={styles.activitySelect}
                            options={activities}
                            onChange={onActivity}
                            value={String(selected?.id)}
                        />
                    </div>
                )}
                <div className={styles.activity}>
                    <div className={styles.top}>
                        <div className={styles.imageWrapper}>
                            {parseImage(selected?.image) && (
                                <>
                                    <Spinner
                                        className={styles.imageSpinner}
                                        overlay={true}
                                    />
                                    <LoadImage
                                        className={styles.image}
                                        srcId={parseImage(selected?.image)}
                                        alt={selected?.name}
                                    />
                                </>
                            )}
                        </div>
                        <div className={styles.topContent}>
                            <h2>{selected?.name}</h2>
                            <SkillActivityStatus
                                activity={selected.id}
                                className={styles.status}
                                community={community}
                                getTranslation={getTranslation}
                                label={getTranslation('yourstatus')}
                                onChange={onStatusChange}
                            />
                        </div>
                    </div>
                    <RenderContent className={styles.content} content={selected?.description} />
                    <div className={styles.feed}>
                        <h4>{getTranslation('subscriptions')}</h4>
                        <SkillActivitySubscriptions
                            community={community}
                            current={status}
                            id={selected.id}
                            getTranslation={getTranslation}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.tray}>
                <Button
                    label={getTranslation('close')}
                    onClick={onClose}
                />
            </div>
        </div>
    )
}

export default SkillActivity